
import Vue from "vue";
import { DefaultEditTab, getVisibleDefaultEditTabs } from "@/utils/tabs/default-edit-tabs";
import { ToolbarService } from "@/services/toolbar-service";
import AppProjectEditGeneral from "./ProjectEditGeneral.vue";
import AppCustomViewTabFrames from "@/components/browse/CustomViewTabFrames.vue";
import { DossierService } from "@/services/dossier-service";
import AppProjectEditExtraFields from "./ProjectEditExtraFields.vue";
import AppProjectEditAwsDocuments from "./ProjectEditAwsDocuments.vue";
import {ProjectEditState} from "@/utils/project/project-edit-state";
import {DossierConfigService, ProjectService, UserConfigService} from "@/services";
import AppExtraFieldTab from "@/components/ExtraFieldTab.vue";
import { ExtraFieldTabConfig } from "@/models/dossier-configs/extra-field-tab-config";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";
import { Project } from "@/models/base";

export default Vue.extend({
	data() {
		return {
			id: 0,
			activeTab: 0,
			refresh: 0
		};
	},
	props: {
		state: {
			required: true,
			type: Object as () => ProjectEditState
		},
	},
	computed: {
		colWidth():number{
			return 12;
		},
		otherTabColWidth():number{
			return 12;
		},
		defaultTabs(): DefaultEditTab[] {
			return getVisibleDefaultEditTabs(23);
		},
		currentTabKey(): string {
			return this.defaultTabs[this.activeTab]?.key || "";
		},
		tabs(): any {
			let t = this.defaultTabs.map(t=>t.label());
			let e = UserConfigService.getCustomViewTabs();
			let v = e.getTabNamesForBrowse(23);
			return [...t, ...v, ...this.extraFieldNamesConfig.getTabNames()];
		},
		customViewTabs(){
			return UserConfigService.getCustomViewTabsForBrowse(23);
		},
		extraFieldNamesConfig():ExtraFieldNamesConfig {
			return DossierConfigService.getExtraFieldNamesConfigs().ProjectNames;
		},
		extraFieldTabs():ExtraFieldTabConfig[] {
			return this.extraFieldNamesConfig.getTabs();
		},
		extraFieldTabStart():number {
			return this.defaultTabs.length + this.customViewTabs.length;
		},
	},
	methods: {
		onUpdateParent(event: Project){
			this.state.project = new Project(event);
		},
		async closeSaleBrowse(){
			await this.state.fetch();
			this.activeTab=0;
		},
		async save(){
			if(this.state.project.ID){
				var project = await ProjectService.putProject(this.state.project);
				this.$emit("cancel");
			}else{
				var project = await ProjectService.saveProject(this.state.project);
				this.$emit("save",project);
			}
			this.$emit("update:project", project);
			this.$wf.notify(this.$ct("common.saved").toString(), "success", 3000, "check");
		},
		async cancel() {
			this.$emit("cancel");
		},
		triggerAction(value:string){
			this.$emit("input",value);
		},
	},
	async mounted() {
		if (this.state.project.ID) {
			ToolbarService.title = this.$ct("edit-project");
		} else {
			ToolbarService.title = this.$ct("new-project");
		}
	},
	async created(){
		await DossierService.getUsers();
	},
	components: {
		AppProjectEditExtraFields,
		AppProjectEditAwsDocuments,
		AppProjectEditGeneral,
		AppCustomViewTabFrames,
		AppExtraFieldTab
	},
	i18nEx: {
		componentPrefix: "components.project"
	}
});
